export const state = {
    isAuthenticated: false,
    accessToken: '',
    oauthAccessToken: '',
    oauthRefreshToken: '',
    authProvider: 'ofmconnect',
    jti: '',
    secretKey: '',
    apiPermission: [],
    isCheckPermissionByElement: false
}

export const mutations = {
    SET_IS_AUTHENTICATED ( state, newValue) {
        state.isAuthenticated = newValue
    },
    SET_ACCESS_TOKEN ( state, newValue) {
        state.accessToken = newValue
    },
    SET_OAUTH_ACCESS_TOKEN ( state, newValue) {
        state.oauthAccessToken = newValue
    },
    SET_OAUTH_REFRESH_TOKEN ( state, newValue) {
        state.oauthRefreshToken = newValue
    },
    SET_AUTH_PROVIDER ( state, newValue) {
        state.authProvider = newValue
    },
    SET_JTI ( state, newValue) {
        state.jti = newValue
    },
    SET_SECRET_KEY ( state, newValue) {
        state.secretKey = newValue
    },
    SET_REMOVE_ALL ( state ) {
        state.isAuthenticated = false
        state.jti = ''
        state.secretKey = ''
        state.accessToken = ''
        state.oauthAccessToken = ''
        state.oauthRefreshToken = ''
        state.authProvider = 'ofmconnect'
    },
    REMOVE_EXPIRE_TOKEN (state) {
        state.isAuthenticated = false
        state.jti = ''
        state.secretKey = ''
        state.accessToken = ''
        state.oauthAccessToken = ''
        state.oauthRefreshToken = ''
        state.authProvider = 'ofmconnect'
    },
    SET_CHECKPERMISSION_BY_ELEMENT_FLAG(state, flag) {
        state.isCheckPermissionByElement = flag
        window.location.reload()
    },
}

export const getters = {
    getIsAuthenticated: state => state.isAuthenticated,
    getAccessToken: state => state.accessToken,
    getOauthAccessToken: state => state.oauthAccessToken,
    getOauthRefreshToken: state => state.oauthRefreshToken,
    getAuthProvider: state => state.authProvider,
    getjti: state => state.jti,
    getApiPermission: state => state.apiPermission,
    getCheckPermissionByElementFlag: state => state.isCheckPermissionByElement,
    getSecretKey: state => state.secretKey
}

export const actions = {
    init({ dispatch }) {
        dispatch('validate')
    },
    removeExpireToken({ commit}) {
        return new Promise(resolve => {
            commit('REMOVE_EXPIRE_TOKEN')
            resolve()
        })
    },
    removeAllAuthen ({ commit }) {
        // localStorage.setItem('isAuthenticated',false)
        // localStorage.setItem('accessToken','')
        // localStorage.setItem('jti','')
        // localStorage.setItem('secretKey','')
        // console.log('tefsfssf')
        return new Promise(resolve => {
            commit('SET_REMOVE_ALL')
            resolve()
          })

    },  
    setIsAuthenticated ({ commit },{ isAuthenticated } = {}) {
        // localStorage.setItem('isAuthenticated',isAuthenticated)
        return new Promise(resolve => {
            commit('SET_IS_AUTHENTICATED', isAuthenticated)
            resolve()
          })
    },
    setAccessToken ({ commit },{ accessToken } = {}) {
        // localStorage.setItem('accessToken',accessToken)
        return new Promise(resolve => {
            commit('SET_ACCESS_TOKEN', accessToken)
            resolve()
          })
    },
    setOAuthAccessToken ({ commit },{ oauthAccessToken } = {}) {
        // localStorage.setItem('accessToken',accessToken)
        return new Promise(resolve => {
            commit('SET_OAUTH_ACCESS_TOKEN', oauthAccessToken)
            resolve()
          })
    },
    setOAuthRefreshToken ({ commit },{ oauthRefreshToken } = {}) {
        // localStorage.setItem('accessToken',accessToken)
        return new Promise(resolve => {
            commit('SET_OAUTH_REFRESH_TOKEN', oauthRefreshToken)
            resolve()
          })
    },
    setAuthProvider ({ commit },{ authProvider } = {}) {     
       // console.log('authProvider', authProvider)
        // localStorage.setItem('accessToken',accessToken)
        return new Promise(resolve => {
            commit('SET_AUTH_PROVIDER', authProvider)
            resolve()
          })
    },
    setjti ({ commit },{ jti } = {}) {
        // localStorage.setItem('jti',jti)
        return new Promise(resolve => {
            commit('SET_JTI', jti)
            resolve()
          })
    },
    setSecretKey ({ commit },{ secretKey } = {}) {
        // localStorage.setItem('secretKey',secretKey)
        return new Promise(resolve => {
            commit('SET_SECRET_KEY', secretKey)
            resolve()
          })

    },
    setCheckPermissionByElementFlag({ commit }, flag) {
        // localStorage.setItem('isCheckPermissionByElement', flag)
        return new Promise(resolve => {
            commit('SET_CHECKPERMISSION_BY_ELEMENT_FLAG', flag)
        })
    },
}
